import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_transactions_list = (params) => {
  return api.post(`${ApiEndpointConstants.GETTRANSACTIONSLIST}`, params);
};
